<template>
	<div class="wrap pt-15 pb-13">
		<h2 class="px-4 mb-2sub--title text-center primary--text">
			{{ $t('easy-to-start.sub-title') }}
		</h2>
		<h1
			class="px-4 font-weight-bold main--title text-center mb-7"
			v-html="$t('easy-to-start.title')"
		></h1>
		<div style="overflow-x: scroll; scroll-behavior: smooth" id="scroll-target">
			<div
				style="height: 75px"
				class="pl-4 d-flex align-center"
				:style="language === 'ja' ? 'width: 955px;' : 'width: 730px;'"
			>
				<div
					class="button"
					@click="active = 1"
					:class="{ active: active === 1 }"
				>
					<div class="number">1</div>
					{{ $t('easy-to-start.menu-1') }}
				</div>
				<div
					class="button"
					@click="active = 2"
					:class="{ active: active === 2 }"
				>
					<div class="number">2</div>
					{{ $t('easy-to-start.menu-2') }}
				</div>
				<div
					class="button"
					@click="active = 3"
					:class="{ active: active === 3 }"
				>
					<div class="number">3</div>
					{{ $t('easy-to-start.menu-3') }}
				</div>
				<div
					class="button"
					@click="active = 4"
					:class="{ active: active === 4 }"
				>
					<div class="number">4</div>
					{{ $t('easy-to-start.menu-4') }}
				</div>
			</div>
		</div>

		<div class="px-4">
			<card-1
				v-if="active === 1"
				class="mx-auto"
				style="max-width: 335px; height: 425px"
			/>
			<card-2
				v-if="active === 2"
				class="mx-auto"
				style="max-width: 335px; height: 425px"
			/>
			<card-3
				v-if="active === 3"
				class="mx-auto"
				style="max-width: 335px; height: 425px"
			/>
			<card-4
				v-if="active === 4"
				class="mx-auto"
				style="max-width: 335px; height: 425px"
			/>
		</div>
	</div>
</template>

<script>
import Card1 from './easy-to-start/Card1'
import Card2 from './easy-to-start/Card2'
import Card3 from './easy-to-start/Card3'
import Card4 from './easy-to-start/Card4'

export default {
	components: {
		Card1,
		Card2,
		Card3,
		Card4,
	},
	data() {
		return {
			active: 1,
		}
	},
	computed: {
		leftPosition() {
			const positions =
				this.language === 'ja' ? [20, 180, 423, 576] : [10, 175, 370, 476]
			// this.language === 'ja' ? [17, 182, 315, 467] : [17, 177, 307, 422]
			return positions[this.active - 1]
		},
		language() {
			return this.$store.getters['language']
		},
	},
	watch: {
		active() {
			var elmnt = document.getElementById('scroll-target')
			elmnt.scrollLeft = this.leftPosition - 10
		},
	},
}
</script>

<style lang="scss" scoped>
.wrap {
	background-color: #f1f5ff;
}

.button {
	padding: 10px 18px 10px 15px;
	margin-right: 10px;
	object-fit: contain;
	border-radius: 23px;

	font-size: 16px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.56;
	letter-spacing: -0.5px;
	color: #78879d;
	.number {
		margin-right: 5px;
		display: inline-block;
		width: 22px;
		height: 22px;
		padding-left: 7px;
		border-radius: 50px;
		font-size: 14px;
		font-weight: bold;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.79;
		letter-spacing: -0.44px;
	}
}
.button.active {
	color: #006cf0;
	background-color: #fff;
	box-shadow: 0 10px 30px 0 rgba(33, 51, 82, 0.1);
	.number {
		background-color: #006cf0;
		color: #fff;
	}
}
</style>
